import { render, staticRenderFns } from "./ShareFolderModal.vue?vue&type=template&id=438fa146&scoped=true&lang=pug"
import script from "./ShareFolderModal.vue?vue&type=script&lang=js"
export * from "./ShareFolderModal.vue?vue&type=script&lang=js"
import style0 from "./ShareFolderModal.vue?vue&type=style&index=0&id=438fa146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fa146",
  null
  
)

export default component.exports